"use client";

import React, { useEffect, useState } from "react";
import "./join.css";
import "./join2.css";
import { fetchAPI } from "../../utils/api";
import {
  accountTypesRes,
  banksListRes,
  countriesRes,
  provincesRes,
  citiesRes,
  officesRes,
} from "../finder/data";
import Popup from "./popup";
import axios from "axios";
import { phoneCodes } from "../../utils/phoneCodes";
import jwt from "jsonwebtoken";
import { useSearchParams } from "next/navigation";
import dayjs from "dayjs";
import CryptoJS from "crypto-js";
import { FaExternalLinkAlt } from "react-icons/fa";
import DatePicker from "react-datepicker";
import { addMonths, lastDayOfMonth, differenceInDays } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";

function SignUpForm() {
  const isAllowedDate = (date) => {
    const today = new Date();
    const lastDayThisMonth = lastDayOfMonth(today);
    const lastDayNextMonth = lastDayOfMonth(addMonths(today, 1));
    const lastDayFollowingMonth = lastDayOfMonth(addMonths(today, 2));

    // Check if today is within the last 4 days of the current month
    const daysRemaining = differenceInDays(lastDayThisMonth, today);
    const useNextMonthDates = daysRemaining < 4;

    const date1 = useNextMonthDates ? lastDayNextMonth : lastDayThisMonth;
    const date2 = useNextMonthDates ? lastDayFollowingMonth : lastDayNextMonth;

    return (
      date.getTime() === date1.getTime() || date.getTime() === date2.getTime()
    );
  };

  // Add a state variable to manage the current step of the form
  const [currentStep, setCurrentStep] = useState(1);
  const [title, setTitle] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [idType, setIdType] = useState("RSA ID number");
  const [country, setCountry] = useState("");
  const [SAPSForceNumber, setSAPSForceNumber] = useState("");
  const [verifySAPSForceNumberLoading, setVerifySAPSForceNumberLoading] =
    useState(false);
  const [rank, setRank] = useState("");
  const [assistedByConsultant, setAssistedByConsultant] = useState(false);
  const [consultantNumber, setConsultantNumber] = useState("");
  const [managerNumber, setManagerNumber] = useState("");
  const [city, setCity] = useState("");
  const [cities, setCities] = useState([]);
  const [OPCNumber, setOPCNumber] = useState("");
  const [idNumber, setIdNumber] = useState("");
  const [passportNumber, setPassportNumber] = useState("");
  const [countries, setCountries] = useState([]);
  const [province, setProvince] = useState("");
  const [provinces, setProvinces] = useState([]);
  const [email, setEmail] = useState("");
  const [confirmEmail, setConfirmEmail] = useState("");
  const [physicalAddress1, setPhysicalAddress1] = useState("");
  const [physicalAddress2, setPhysicalAddress2] = useState("");
  const [code1, setCode1] = useState("+27");
  const [code2, setCode2] = useState("+27");
  const [cellphoneNumber, setCellphoneNumber] = useState("");
  const [alternativeCellphone, setAlternativeCellphone] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [accountHolderName, setAccountHolderName] = useState("");
  const [accountType, setAccountType] = useState({ Id: "", name: "" });
  const [bank, setBank] = useState({ Id: "", name: "" });
  const [memberTypeID, setMemberTypeID] = useState(2760);
  const [showPopup, setShowPopup] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [office, setOffice] = useState("");
  // State variable for radio button
  const [isLoading, setIsLoading] = useState(false);
  const [isHeadingToAdumo, setIsHeadingToAdumo] = useState(false);
  const [isAdumoStatus, setIsAdumoStatus] = useState("");
  const [adumoMessage, setAdumoMessage] = useState("");
  const [offices, setOffices] = useState([]);
  const [startDate, setStartDate] = useState(lastDayOfMonth(new Date()));
  const [onceOffFee, setOnceOffFee] = useState("250");
  const [annualFee, setAnnualFee] = useState("99");

  // Step 2 states (only include state that doesn't overlap with Step 1)
  const [selectedOnceOffValue, setSelectedOnceOffValue] = useState("option1");
  const [selectedAnnualValue, setSelectedAnnualValue] = useState("option1");
  const [hasAgreed, setHasAgreed] = useState(false);
  const [retryLoader, setRetryLoader] = useState(false);
  const [hasToSendPaymentLink, setHasToSendPaymentLink] = useState(false);
  const [paymentLinkEmail, setPaymentLinkEmail] = useState("");
  const [paymentLinkConfirmEmail, setPaymentLinkConfirmEmail] = useState("");
  const [paymentLinkCode, setPaymentLinkCode] = useState("+27");
  const [paymentLinkPhone, setPaymentLinkPhone] = useState("");
  const [hasAgreedWhatsapp, setHasAgreedWhatsapp] = useState(true);
  const [banks, setBanks] = useState([]);
  const [accountTypes, setAccountTypes] = useState([]);
  const [isActive, setIsActive] = useState(true);
  const [isActive2, setIsActive2] = useState(false);
  const [ConvertFromMemberID, setConvertFromMemberID] = useState(null);
  const [retryPayload, setRetryPayload] = useState(null);

  const params = useSearchParams();

  const encryptedAdumoPayload = params.get("payload");

  const step2Validation = () => {
    if (title.trim() === "") {
      alert("Please select a title.");
    } else if (firstName.trim() === "") {
      alert("Please enter a first name.");
    } else if (lastName.trim() === "") {
      alert("Please enter a last name.");
    } else if (idType.trim() === "") {
      alert("Please select an ID type.");
    } else if (idNumber.trim() === "" && idType === "RSA ID number") {
      alert("Please enter an ID number.");
    } else if (passportNumber.trim() === "" && idType === "passport number") {
      alert("Please enter a passport number.");
    } else if (email.trim() === "" || !email.includes("@")) {
      alert("Please enter a valid email address.");
    } else if (confirmEmail.trim() === "") {
      alert("Please confirm your email address.");
    } else if (confirmEmail.trim() !== "" && confirmEmail !== email) {
      alert("Emails do not match.");
    } else if (idType === "RSA ID number" && idNumber.trim().length !== 13) {
      alert("ID number should be 13 numerics.");
    } else if (code1.trim() === "+27" && !/^(0\d{9})$/.test(cellphoneNumber)) {
      alert("Please enter a valid phone number.");
    } else if (
      alternativeCellphone.trim() !== "" &&
      code2.trim() === "+27" &&
      !/^(0\d{9})$/.test(alternativeCellphone)
    ) {
      alert("Please enter a valid alternative phone number.");
    } else if (
      physicalAddress1.trim() === "" ||
      physicalAddress2.trim() === ""
    ) {
      alert("Please enter both physical addresses.");
    } else if (!country || !province || !city) {
      alert("Please fill in province and city.");
    } else if (assistedByConsultant && !office) {
      alert("Please select an office name.");
    } else {
      return true;
    }
    return false;
  };

  const step3Validation = () => {
    if (selectedAnnualValue === "option3" && !accountHolderName) {
      alert("Please enter an account holder name.");
      return false;
    }

    if (selectedAnnualValue === "option3" && !accountNumber) {
      alert("Please enter an account number.");
      return false;
    }

    // if account number is not digits only, show alert
    if (selectedAnnualValue === "option3" && !/^\d+$/.test(accountNumber)) {
      alert("Account number should be digits only.");
      return false;
    }

    if (!accountType.Id || !bank.Id) {
      alert("Please select an account type and bank.");
      return false;
    }

    return true;
  };

  useEffect(() => {
    if (params.get("payment-result")) {
      setCurrentStep(5);
      setIsAdumoStatus(params.get("payment-result"));

      if (params.get("payment-result") === "failed") {
        setAdumoMessage(params.get("message"));
        setRetryPayload(
          JSON.parse(window.localStorage.getItem("adumo-payment-retry-object"))
        );
      }

      if (params.get("payment-result") === "success") {
        window.localStorage.removeItem("adumo-payment-retry-object");
      }

      if (params.get("payment-result") === "pending_approval") {
        // Decrypt the data
        const bytes = CryptoJS.AES.decrypt(
          decodeURIComponent(encryptedAdumoPayload),
          process.env.NEXT_PUBLIC_FLP_PAYLOAD_SECRET_KEY
        );
        const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

        fetchAPI("/CCPaymentReturnAdumo", "POST", decryptedData)
          .then((res) => {
            setCurrentStep(5);
            setIsAdumoStatus("success");
            typeof window !== "undefined" &&
              window.localStorage.removeItem("adumo-payment-retry-object");
          })
          .catch((err) => console.log(err));
      }
    }
  }, [params]);

  useEffect(() => {
    if (country) {
      provincesRes(country.Id || country)
        .then((res) => {
          if (res?.Data?.length > 0) {
            setProvinces(res.Data);
            setProvince(res.Data[0]?.Id);
          } else {
            setProvince("");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [country]);

  useEffect(() => {
    if (province) {
      citiesRes(province.Id || province)
        .then((res) => {
          if (res?.Data) {
            setCities(res.Data);
            setCity(res.Data[0]?.ID);
          } else {
            setCity("");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [province]);

  useEffect(() => {
    countriesRes
      .then((res) => {
        if (res?.Data) {
          setCountries(res.Data);
          setCountry(res.Data.find((c) => c.name === "South Africa"));
        }
      })
      .catch((error) => {
        console.log(error);
      });

    officesRes
      .then((res) => {
        if (res?.Data) {
          setOffices(res.Data);
          setOffice(
            res.Data.find(
              (office) => office.name === "First Leisure Website – Ekko"
            )?.Id
          );
        }
      })
      .catch((error) => {
        console.log(error);
      });

    banksListRes
      .then((res) => {
        if (res?.Data) {
          setBanks(res.Data);
          setBank(res.Data[2]);
        }
      })
      .catch((error) => {
        console.log(error);
      });

    accountTypesRes
      .then((res) => {
        if (res?.Data) {
          setAccountTypes(res.Data);
          setAccountType(res.Data[2]);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  // Function to dynamically change the label for ID input based on the selected ID type
  const getIdInputLabel = () => {
    if (idType === "RSA ID number") {
      return "RSA ID Number:";
    } else if (idType === "passport number") {
      return "Passport Number:";
    }
    return "RSA ID Number:";
  };

  const showConsultantFields = () => {
    if (assistedByConsultant) {
      return (
        <>
          <section className="step2">
            <div className="form-item fi-50">
              <label>Consultant Number:</label>
              <input
                type="text"
                value={consultantNumber}
                onChange={(e) => setConsultantNumber(e.target.value)}
              />
            </div>
            <div className="form-item fi-50">
              <label>Manager Number:</label>
              <input
                type="text"
                value={managerNumber}
                onChange={(e) => setManagerNumber(e.target.value)}
              />
            </div>
          </section>
          <section className="step2">
            <div className="form-item fi-100">
              <label>Office Name:</label>
              <select
                value={office}
                onChange={(e) => {
                  setOffice(e.target.value);
                }}
              >
                <option value="" disabled>
                  Select Office Name
                </option>
                {offices.map((option) => (
                  <option key={option.Id} value={option.Id}>
                    {option.name}
                  </option>
                ))}
                {/* Add more office names as needed */}
              </select>
            </div>
          </section>
        </>
      );
    }
    return null;
  };

  const handleClick = () => {
    setIsActive(true);
    setIsActive2(false);

    setOnceOffFee(onceOffFee);
    setSelectedAnnualValue("option1");
  };

  const handleClick2 = () => {
    setIsActive2(true);
    setIsActive(false);
    setSelectedAnnualValue("option3");

    setAnnualFee(annualFee);
  };

  const handleChange = (event) => {
    setSelectedOnceOffValue(event.target.value);
  };

  useEffect(() => {
    // smooth scroll to id join-now-form
    const joinNowForm = document.getElementById(`join-now-form${currentStep}`);
    if (joinNowForm) {
      joinNowForm.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [currentStep]);

  // Handle form submission for Step 1
  const handleSubmitStep1 = async (e) => {
    e.preventDefault();

    try {
      setVerifySAPSForceNumberLoading(true);
      await fetchAPI(
        `/VerifyMemberForceNumber/?ForceNumber=${SAPSForceNumber}`
      ).then((res) => {
        setVerifySAPSForceNumberLoading(false);
        if (res?.Data) {
          setFirstName(res.Data.FirstName);
          setLastName(res.Data.Surname);
          setEmail(res.Data.Email);
          setRank(res.Data.Rank);
          setConvertFromMemberID(res.Data.MemberID);
          setShowSuccessPopup(true);
        } else {
          setShowPopup(true);
        }
      });
    } catch (error) {
      setShowPopup(true);
      setVerifySAPSForceNumberLoading(false);
    }
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  const proceedToNextStep = () => {
    setShowSuccessPopup(false);
    setCurrentStep(2);
  };

  // Handle form submission for Step 2
  const handleSubmitStep2 = (e) => {
    e.preventDefault();

    if (!step2Validation()) return;

    // if either of consultant number or manager number is empty, show alert
    if (assistedByConsultant && (!consultantNumber || !managerNumber)) {
      alert("Please enter both consultant and manager numbers.");
      return;
    }

    setCurrentStep(3);
  };

  // Handle form submission for Step 3
  const handleSubmitStep3 = async (e) => {
    e.preventDefault();

    // credit card or debit order radio button should be selected
    if (!selectedOnceOffValue && !selectedAnnualValue) {
      alert("Please select a payment method.");
      return;
    }

    // check if start date is not selected
    if (!startDate) {
      alert("Please select a start date.");
      return;
    }

    // check if terms and conditions are not agreed
    if (!hasAgreed) {
      alert("Please agree to the terms and conditions.");
      return;
    }

    // if debit order is selected, proceed to next step
    if (selectedAnnualValue === "option3" && currentStep === 3) {
      setCurrentStep(4);
      return;
    }

    // if current step is 4, check if all fields are filled in
    if (currentStep === 4 && !step3Validation()) return;

    if (
      hasToSendPaymentLink &&
      paymentLinkEmail === "" &&
      paymentLinkPhone === ""
    ) {
      alert(
        "Please enter an email address or phone number to send payment link."
      );
      setIsLoading(false);
      return;
    }

    if (
      hasToSendPaymentLink &&
      paymentLinkEmail !== "" &&
      !paymentLinkEmail.includes("@")
    ) {
      alert("Please enter a valid email address.");
      setIsLoading(false);
      return;
    }

    if (
      hasToSendPaymentLink &&
      paymentLinkEmail !== "" &&
      paymentLinkEmail !== paymentLinkConfirmEmail
    ) {
      alert("Emails do not match.");
      setIsLoading(false);
      return;
    }

    if (
      hasToSendPaymentLink &&
      paymentLinkPhone !== "" &&
      !/^(0\d{9})$/.test(paymentLinkPhone)
    ) {
      alert("Please enter a valid phone number.");
      setIsLoading(false);
      return;
    }

    setIsLoading(true);

    try {
      // Simulate API call to submit form data
      const response = await fetchAPI("/SignUpMember", "POST", {
        CompanyID: 56,
        MemberTypeID: memberTypeID,
        IsCompany: false,
        Person: {
          Title: title,
          MemberID: 0,
          FirstName: firstName,
          LastName: lastName,
          UsePassport: idType === "passport number",
          IdentityNumber: idNumber,
          PassportNumber: idType === "passport number" ? idNumber : "",
          Email: email,
          Cellphone: cellphoneNumber,
          Telephone: alternativeCellphone,
        },
        Spouse: {
          Title: null,
          FirstName: null,
          LastName: null,
          UsePassport: false,
          IdentityNumber: null,
          PassportNumber: "",
          Email: null,
          Cellphone: null,
          Telephone: null,
        },
        Address: {
          AddressLine1: physicalAddress1,
          AddressLine2: physicalAddress2,
          Country: country.name,
          CountryID: country.Id,
          Province: province.name,
          ProvinceID: province,
          City: city.Name,
          CityID: city,
          PostalCode: +city.PostalCode,
        },
        CompanyName: "",
        CompanyRegsitration: "",
        AssistedSale: assistedByConsultant ? "Yes" : "No",
        ConsultantId: +consultantNumber,
        ManagerId: +managerNumber,
        FranchiseBranchID: +office,
        DidReadTerms: hasAgreed,
        AcceptTerms: hasAgreed,
        DepositPercentage: 0,
        InstallmentMonths: 0,
        DepositPaymentDate: dayjs().toISOString().split("T")[0],
        HasDepositDebitOrder: selectedAnnualValue === "option3",
        HasInstallmentDebitOrder: selectedAnnualValue === "option3",
        AnnualPayment: false,
        InstallmentPaymentDate: dayjs(startDate)
          .add(1, "day")
          .toISOString()
          .split("T")[0],
        ConvertFromMemberID,
        DepositTypeID: 1,
        OpcNumber: OPCNumber,
        UpdateAction: "",
      });

      if (response?.Authenticated) {
        // sign up with credit card
        const virtualResponse = await fetchAPI(
          "/SignUpPaymentRequestMyVirtual",
          "POST",
          {
            ForDO: true,
            DepositTypeID: 1,
            MemberID: response.MemberID,
            CompanyID: 56,
            AccountHolderName: accountHolderName,
            AccountNumber: accountNumber,
            AccountTypeID: accountType.Id,
            BankID: bank.Id,
            HasInstallmentDebitOrder: selectedAnnualValue === "option3",
            NextDebitOrder: dayjs(startDate)
              .add(1, "day")
              .toISOString()
              .split("T")[0],
            SendPaymentLink: hasToSendPaymentLink,
            PaymentLinkEmail: paymentLinkEmail,
            PaymentLinkCellNumber: paymentLinkPhone.startsWith("0")
              ? paymentLinkCode + paymentLinkPhone.slice(1)
              : paymentLinkCode + paymentLinkPhone,
          }
        );

        if (virtualResponse?.Result) {
          if (hasToSendPaymentLink) {
            setCurrentStep(5);
            setIsAdumoStatus("success");
            setAdumoMessage(
              virtualResponse.Message ||
                "Payment link sent successfully. Please follow the instructions in the email that was sent to complete your sign up"
            );
            return;
          }

          setIsHeadingToAdumo(true);
          handleAdumoPayment(virtualResponse);
          window.localStorage.setItem(
            "adumo-payment-retry-object",
            JSON.stringify({
              ForDO: true,
              DepositTypeID: 1,
              MemberID: response.MemberID,
              CompanyID: 56,
              AccountHolderName: accountHolderName,
              AccountNumber: accountNumber,
              AccountTypeID: accountType.Id,
              BankID: bank.Id,
              HasInstallmentDebitOrder: selectedAnnualValue === "option3",
              NextDebitOrder: dayjs(startDate)
                .add(1, "day")
                .toISOString()
                .split("T")[0],
              SendPaymentLink: false,
              PaymentLinkEmail: "",
              PaymentLinkCellNumber: "",
            })
          );
        } else {
          fetchAPI("/RetryPaymentRequestMyVirtual", "POST", {
            ForDO: true,
            DepositTypeID: 1,
            MemberID: response.MemberID,
            CompanyID: 56,
            AccountHolderName: accountHolderName,
            AccountNumber: accountNumber,
            AccountTypeID: accountType.Id,
            BankID: bank.Id,
            HasInstallmentDebitOrder: selectedAnnualValue === "option3",
            NextDebitOrder: dayjs(startDate)
              .add(1, "day")
              .toISOString()
              .split("T")[0],
            SendPaymentLink: hasToSendPaymentLink,
            PaymentLinkEmail: paymentLinkEmail,
            PaymentLinkCellNumber: paymentLinkPhone.startsWith("0")
              ? paymentLinkCode + paymentLinkPhone.slice(1)
              : paymentLinkCode + paymentLinkPhone,
          })
            .then((res) => {
              if (res?.Result) {
                if (hasToSendPaymentLink) {
                  setCurrentStep(5);
                  setIsAdumoStatus("success");
                  setAdumoMessage(
                    res.Message ||
                      "Payment link sent successfully. Please follow the instructions in the email that was sent to complete your sign up"
                  );
                  return;
                }

                setIsHeadingToAdumo(true);
                handleAdumoPayment(res);

                window.localStorage.setItem(
                  "adumo-payment-retry-object",
                  JSON.stringify({
                    ForDO: true,
                    DepositTypeID: 1,
                    MemberID: response.MemberID,
                    CompanyID: 55,
                    AccountHolderName: accountHolderName,
                    AccountNumber: accountNumber,
                    AccountTypeID: accountType.Id,
                    BankID: bank.Id,
                    HasInstallmentDebitOrder: selectedAnnualValue === "option3",
                    NextDebitOrder: dayjs(startDate)
                      .add(1, "day")
                      .toISOString()
                      .split("T")[0],
                    SendPaymentLink: hasToSendPaymentLink,
                    PaymentLinkEmail: paymentLinkEmail,
                    PaymentLinkCellNumber: paymentLinkPhone.startsWith("0")
                      ? paymentLinkCode + paymentLinkPhone.slice(1)
                      : paymentLinkCode + paymentLinkPhone,
                  })
                );
              } else {
                if (hasToSendPaymentLink) {
                  window.sessionStorage.setItem(
                    "adumo-payment-retry-object",
                    JSON.stringify({
                      ForDO: true,
                      DepositTypeID: 1,
                      MemberID: response.MemberID,
                      CompanyID: 56,
                      AccountHolderName: accountHolderName,
                      AccountNumber: accountNumber,
                      AccountTypeID: accountType.Id,
                      BankID: bank.Id,
                      HasInstallmentDebitOrder:
                        selectedAnnualValue === "option3",
                      NextDebitOrder: dayjs(startDate)
                        .add(1, "day")
                        .toISOString()
                        .split("T")[0],
                      SendPaymentLink: true,
                      PaymentLinkEmail: paymentLinkEmail,
                      PaymentLinkCellNumber: paymentLinkPhone.startsWith("0")
                        ? paymentLinkCode + paymentLinkPhone.slice(1)
                        : paymentLinkCode + paymentLinkPhone,
                    })
                  );
                  setCurrentStep(5);
                  setIsAdumoStatus("failed");
                  setAdumoMessage(res.Message);

                  return;
                }

                alert("Credit card failed to be registered");
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }

        setIsLoading(false);
      } else {
        setIsLoading(false);

        if (response?.status === 500) {
          alert("Something went wrong, please retry.");
        } else {
          alert("Your email already exists in our system.");
        }
      }
    } catch (error) {
      setIsLoading(false);

      alert(error?.message || "Something went wrong, please retry.");
    }
  };

  const handleRetrySignupVirtual = (payload, paymentLink = false) => {
    payload = payload || retryPayload;
    setRetryLoader(true);
    fetchAPI("/RetryPaymentRequestMyVirtual", "POST", {
      ForDO: payload?.ForDO,
      DepositTypeID: payload?.DepositTypeID,
      MemberID: payload?.MemberID,
      CompanyID: payload?.CompanyID,
      AccountHolderName: payload?.AccountHolderName,
      AccountNumber: payload?.AccountNumber,
      AccountTypeID: payload?.AccountTypeID,
      BankID: payload?.BankID,
      HasInstallmentDebitOrder: payload?.HasInstallmentDebitOrder,
      NextDebitOrder: payload?.NextDebitOrder,
      SendPaymentLink: payload?.SendPaymentLink,
      PaymentLinkEmail: payload?.PaymentLinkEmail,
      PaymentLinkCellNumber: payload?.PaymentLinkCellNumber,
    })
      .then((res) => {
        if (res?.Result) {
          handleAdumoPayment(res);
          window.sessionStorage.setItem(
            "adumo-payment-retry-object",
            JSON.stringify(payload)
          );
        } else {
          alert("Credit card failed to be registered");
        }
        setRetryLoader(false);
      })
      .catch((err) => {
        setRetryLoader(false);
      });
  };

  const handleAdumoPayment = async (virtualResponse) => {
    const payload = {
      iss: virtualResponse?.Data?.CO_ID,
      cuid: virtualResponse?.Data?.MerchantIdReference,
      auid: virtualResponse?.Data?.ApplicationIdReference,
      amount: virtualResponse?.Data?.CC_Amount,
      mref: virtualResponse?.Data?.Reference,
      iat: Date.now() / 1000 - 60,
      exp: Date.now() / 1000 + 600,
    };

    // Generate the JWT token with your payload
    const token = jwt.sign(payload, virtualResponse?.Data?.Jti);

    // send data to adumo for payment
    const formData = new FormData();
    formData.append("frequency", virtualResponse?.Data?.frequency);
    formData.append("collectionDay", virtualResponse?.Data?.collectionDay);
    formData.append("accountNumber", virtualResponse?.Data?.accountNumber);
    formData.append("startDate", virtualResponse?.Data?.startDate);
    formData.append("endDate", virtualResponse?.Data?.endDate);
    formData.append("collectionValue", virtualResponse?.Data?.collectionValue);
    formData.append("contactNumber", virtualResponse?.Data?.contactNumber);
    formData.append("mobileNumber", virtualResponse?.Data?.mobileNumber);
    formData.append("emailAddress", virtualResponse?.Data?.emailAddress);
    formData.append("shouldSendSms", virtualResponse?.Data?.shouldSendSms);
    formData.append("shouldSendEmail", virtualResponse?.Data?.shouldSendEmail);
    // formData.append("flow", "CARD");
    formData.append("MerchantID", virtualResponse?.Data?.MerchantIdReference);
    formData.append(
      "ApplicationID",
      virtualResponse?.Data?.ApplicationIdReference
    );
    formData.append("MerchantReference", virtualResponse?.Data?.Reference);
    formData.append("Token", token);
    formData.append("Amount", virtualResponse?.Data?.CC_Amount);
    // formData.append("puid", virtualResponse?.Data?.puid);
    formData.append("RedirectSuccessfulURL", virtualResponse?.Data?.SuccessUrl);
    formData.append("RedirectFailedURL", virtualResponse?.Data?.FailureUrl);
    formData.append("DisplayPrice", virtualResponse?.Data?.CC_Amount);
    formData.append("txtCurrencyCode", "ZAR");

    axios
      .post(`${process.env.NEXT_PUBLIC_ADMIN_API_URL}/adumo-payment`, formData)
      .then((res) => {
        typeof window !== "undefined" && window.location.replace(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // Render the appropriate form step based on the currentStep state
  if (currentStep === 1) {
    return (
      <section className="section-bg" id="join-now-form1">
        <div className="join-cont">
          <div className="count-cont">
            <span className={currentStep === 1 ? "active" : ""}>01</span>
            <span>02</span>
            <span>03</span>
            <span>04</span>
          </div>
          <div className="join-head-cont">
            <h2 style={{ fontSize: "1.8em" }}>
              Please enter your SAPS force number
            </h2>
          </div>
          <form onSubmit={handleSubmitStep1}>
            <section>
              <div className="form-item mfn fi-40">
                <label>SAPS FORCE NUMBER</label>
                <input
                  type="text"
                  value={SAPSForceNumber}
                  onChange={(e) => setSAPSForceNumber(e.target.value)}
                />
              </div>
            </section>
            <div className="btn-cont mobile-btn-cont">
              <button
                className={`btn mobile-btn-join ${
                  !SAPSForceNumber ? "disabled" : ""
                }`}
                type="submit"
                disabled={!SAPSForceNumber}
              >
                {verifySAPSForceNumberLoading ? "VERIFYING..." : "PROCEED"}
              </button>
            </div>
          </form>
        </div>
        {showPopup && (
          <Popup
            header="Oops... Invalid SAPS Force Number"
            message1="We could not validate your SAPS Force Number. In order to join Off Beat Plus, you must be currently be serving with SAPS and have an active Off Beat Membership."
            message2="For assistance please call us on 012 349 1433 or alternatively enter a valid Force Number."
            onClose={closePopup}
            close="Retry"
          />
        )}
        {showSuccessPopup && (
          <Popup
            header="IMPORTANT NOTICE"
            message1="I understand that Off Beat Plus is an additional membership to my Off Beat Holiday Club membership."
            message2="I understand that Off Beat Holiday Club membership must be active and in good standing in order to retain my Off Beat Plus membership."
            onClose={proceedToNextStep}
            close="Continue"
          />
        )}
      </section>
    );
  } else if (currentStep === 2) {
    return (
      <section className="section-bg" id="join-now-form2">
        <div className="join-cont sign-form">
          <div className="count-cont">
            <span
              onClick={() => {
                setCurrentStep(1);
              }}
            >
              01
            </span>
            <span className="active">02</span>
            <span>03</span>
            <span>04</span>
          </div>
          <div className="join-head-cont">
            <h2 style={{ fontSize: "1.8em" }}>Membership Details</h2>
          </div>
          <form onSubmit={handleSubmitStep2}>
            <section className="obh-details step2">
              <h3>Off Beat Holiday Club Membership Details</h3>
              {/* add Force Number, Rank, First Name, Last Name in vertical order, not form */}
              <div className="member-details-row">
                <div className="label">Force Number:</div>
                <div className="value">{SAPSForceNumber}</div>
              </div>
              <div className="member-details-row">
                <div className="label">Rank:</div>
                <div className="value">{rank || "N/A"}</div>
              </div>
              <div className="member-details-row">
                <div className="label">First Name:</div>
                <div className="value">{firstName}</div>
              </div>
              <div className="member-details-row">
                <div className="label">Last Name:</div>
                <div className="value">{lastName}</div>
              </div>
            </section>
            <section className="step2">
              <div className="form-item mt fi-20">
                <label>Title:</label>
                <select
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                >
                  <option value="">Select Title</option>
                  <option value="Mr">Mr</option>
                  <option value="Mrs">Mrs</option>
                  <option value="Dr">Dr</option>
                  <option value="Ms">Ms</option>
                </select>
              </div>
              <div className="form-item  mfn fi-40">
                <label>First Name:</label>
                <input
                  type="text"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                />
              </div>
              <div className="form-item mln fi-40">
                <label>Last Name:</label>
                <input
                  type="text"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                />
              </div>
            </section>
            <section className="step2">
              <div className="form-item fi-60">
                <label>ID Type:</label>
                <select
                  value={idType}
                  onChange={(e) => setIdType(e.target.value)}
                >
                  <option value="RSA ID number">RSA ID number</option>
                  <option value="passport number">passport number</option>
                </select>
              </div>
              <div className="form-item fi-40">
                <label>{getIdInputLabel()}</label>
                <input
                  type={idType === "RSA ID number" ? "number" : "text"}
                  value={idType === "RSA ID number" ? idNumber : passportNumber}
                  onChange={(e) =>
                    idType === "RSA ID number"
                      ? setIdNumber(e.target.value)
                      : setPassportNumber(e.target.value)
                  }
                  minLength={idType === "RSA ID number" ? 13 : 0}
                />
              </div>
            </section>
            <section className="step2">
              <div className="form-item fi-60">
                <label>Email Address:</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className="form-item fi-10">
                <label>Code:</label>
                <select
                  value={code1}
                  onChange={(e) => setCode1(e.target.value)}
                  className="no-spinners"
                >
                  {phoneCodes.map((option) => (
                    <option key={option.code} value={option.code}>
                      {`${option.country} (${option.code})`}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-item fi-30">
                <label>Cellphone Number:</label>
                <input
                  type="tel"
                  value={cellphoneNumber}
                  onChange={(e) => setCellphoneNumber(e.target.value)}
                />
              </div>
            </section>
            <section className="step2">
              <div className="form-item fi-60">
                <label>Confirm Email Address:</label>
                <input
                  type="email"
                  value={confirmEmail}
                  onChange={(e) => setConfirmEmail(e.target.value)}
                  onPaste={(e) => e.preventDefault()}
                />
              </div>
              <div className="form-item fi-10">
                <label>Code:</label>
                <select
                  value={code2}
                  onChange={(e) => setCode2(e.target.value)}
                  className="no-spinners"
                >
                  {phoneCodes.map((option) => (
                    <option key={option.code} value={option.code}>
                      {`${option.country} (${option.code})`}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-item fi-30">
                <label>Alternative Cellphone Number:</label>
                <input
                  type="tel"
                  value={alternativeCellphone}
                  onChange={(e) => setAlternativeCellphone(e.target.value)}
                />
              </div>
            </section>
            <section className="step2">
              <div className="form-item fi-100">
                <label>Physical Address Line 1:</label>
                <input
                  type="text"
                  value={physicalAddress1}
                  onChange={(e) => setPhysicalAddress1(e.target.value)}
                />
              </div>
            </section>
            <section className="step2">
              <div className="form-item fi-100">
                <label>Physical Address Line 2:</label>
                <input
                  type="text"
                  value={physicalAddress2}
                  onChange={(e) => setPhysicalAddress2(e.target.value)}
                />
              </div>
            </section>
            <section className="step2">
              <div className="form-item fi-60">
                <label>Country:</label>
                <select
                  value={country.Id}
                  onChange={(e) => {
                    setCountry(e.target.value);
                    // if country is South Africa, reset provinces and cities
                    if (
                      +e.target.value !==
                      countries.find((c) => c.name === "South Africa")?.Id
                    ) {
                      setProvince("");
                      setCity("");
                    }
                  }}
                >
                  <option value="">Select Country</option>
                  {countries.map((option) => (
                    <option key={option.Id} value={option.Id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-item fi-40">
                <label>Province:</label>
                {
                  // if country is South Africa, show provinces dropdown, otherwise show input field
                  province !== "" ? (
                    <select
                      value={province}
                      onChange={(e) => setProvince(e.target.value)}
                    >
                      <option value="">Select Province</option>
                      {provinces.map((option) => (
                        <option key={option.Id} value={option.Id}>
                          {option.name}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <input
                      type="text"
                      value={province}
                      onChange={(e) => setProvince(e.target.value)}
                    />
                  )
                }
              </div>
            </section>
            <section className="step2">
              <div className="form-item fi-60">
                <label>City/SUBURB:</label>
                {
                  // if country is South Africa, show cities dropdown, otherwise show input field
                  city !== "" ? (
                    <select
                      value={city}
                      onChange={(e) => setCity(e.target.value)}
                    >
                      <option value="">Select City</option>
                      {cities.map((option) => (
                        <option key={option.ID} value={option.ID}>
                          {option.Name}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <input
                      type="text"
                      value={city}
                      onChange={(e) => setCity(e.target.value)}
                    />
                  )
                }
              </div>
            </section>
            <section className="step2">
              <div className="form-item fi-100 radio">
                <label>Did anyone assist you in making this purchase?</label>
                <div className="assist-radio-cont" width="100%">
                  <label>
                    <input
                      type="radio"
                      name="assistedByConsultant"
                      value="no"
                      checked={!assistedByConsultant}
                      onChange={() => {
                        setAssistedByConsultant(false);
                        setOffice(
                          offices.find(
                            (office) =>
                              office.name === "First Leisure Website – Ekko"
                          )?.Id
                        );
                      }}
                    />
                    No, I made the purchase myself
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="assistedByConsultant"
                      value="yes"
                      checked={assistedByConsultant}
                      onChange={() => setAssistedByConsultant(true)}
                    />
                    Yes, a consultant assisted me
                  </label>
                </div>
              </div>
            </section>
            {showConsultantFields()}
            <div className="btn-cont mobile-btn-cont">
              <button className="btn mobile-btn-join" type="submit">
                SAVE AND PROCEED TO NEXT STEP
              </button>
              <button
                className="btn mobile-btn-join"
                type="button"
                onClick={() => {
                  if (typeof window !== "undefined") window.location.href = "/";
                }}
              >
                CANCEL
              </button>
            </div>
          </form>
        </div>
      </section>
    );
  } else if (currentStep === 3) {
    return (
      <section className="section-bg" id="join-now-form3">
        <div className="join-cont">
          <div className="count-cont">
            <span
              onClick={() => {
                setCurrentStep(1);
              }}
            >
              01
            </span>
            <span
              onClick={() => {
                setCurrentStep(2);
              }}
            >
              02
            </span>
            <span
              className="active"
              onClick={() => {
                setCurrentStep(3);
              }}
            >
              03
            </span>
            <span>04</span>
          </div>
          <div className="join-head-cont">
            {/* <h2>PURCHASE AND PAYMENT OPTIONS</h2> */}
          </div>

          <div id="upgrade-today-parent">
            <h2 className="upgrade-today-title">
              purchase and payment options
            </h2>

            <div className="upgrade-today-content">
              <div className="upgrade-today-1">
                <img
                  src="https://off-beat-cdn.blr1.cdn.digitaloceanspaces.com/top-assest.png"
                  alt="white-shape"
                />
              </div>

              <div className="upgrade-today-2">
                <p style={{ color: "white" }}>
                  Save thousands on things you do everyday! <br /> <br />{" "}
                  BENEFITS:
                </p>
              </div>

              <div className="upgrade-today-3">
                <div className="benefits-list2">
                  <ul>
                    <li>- Flights & Car Hire</li>
                    <li>- Tours & Activities</li>
                  </ul>
                  <ul>
                    <li>- Dining & Coffee</li>
                    <li>- Deals-4-U</li>
                  </ul>
                  <ul>
                    <li>- Holidays</li>
                    <li>- Cruises</li>
                  </ul>
                  <ul>
                    <li>- Movies</li>
                    <li>- Spas</li>
                  </ul>
                </div>
              </div>
            </div>

            <a className="upgrade-btn" href="/join-now">
              JOIN NOW
            </a>

            {/* <div className="upgrade-today-banner">
      <p style={{color:"red" , textAlign:"center"}}>*Off Beat Plus is an additional membership to your <br/> Off Beat Holiday Club membership.</p>
      </div> */}
          </div>

          <form id="form-price" onSubmit={handleSubmitStep3}>
            <section>
              <div className="price-flex-container">
                <h5>ONCE-OFF FEE</h5>
                <div className="item1">
                  <button
                    type="button"
                    className="price-button"
                    style={{ backgroundColor: isActive ? "#187CC0" : "white" }}
                    onClick={handleClick}
                  >
                    <div style={{ color: "black" }}>Amount</div>
                    <div style={{ color: "black" }}>
                      R{Number(onceOffFee).toLocaleString("en-US")}
                    </div>
                  </button>
                </div>
                <h5>PAYMENT METHOD</h5>

                <label>
                  <input
                    className="radiomargin"
                    type="radio"
                    name="radioGroup"
                    value="option1"
                    checked={selectedOnceOffValue === "option1"}
                    onChange={handleChange}
                  />
                  CREDIT / DEBIT CARD
                </label>
                <br />

                <h5>MONTHLY FEE</h5>
                <div className="item2">
                  <button
                    type="button"
                    className="price-button"
                    style={{ backgroundColor: isActive2 ? "#187CC0" : "white" }}
                    onClick={handleClick2}
                  >
                    <div style={{ color: "black" }}>Amount</div>
                    <div style={{ color: "black" }}>
                      R{Number(annualFee).toLocaleString("en-US")}
                    </div>
                  </button>
                </div>
                <h5>PAYMENT METHOD</h5>

                <div className="radio-dual" style={{ gap: "15px" }}>
                  <div className="r1">
                    <label>
                      <input
                        className="radiomargin"
                        type="radio"
                        name="radioGroup2"
                        value="option2"
                        checked={selectedAnnualValue === "option2"}
                        onChange={() => {
                          setSelectedAnnualValue("option2");
                        }}
                        disabled={isActive}
                      />
                      CREDIT CARD
                    </label>
                  </div>
                  <div className="r2">
                    <label>
                      <input
                        className="radiomargin"
                        type="radio"
                        name="radioGroup2"
                        value="option3"
                        checked={selectedAnnualValue === "option3"}
                        onChange={() => {
                          setSelectedAnnualValue("option3");
                        }}
                        disabled={isActive}
                      />
                      DEBIT ORDER
                    </label>
                  </div>
                </div>
              </div>
            </section>
            <br />
            <section className="start-date">
              <div style={{ display: "flex", justifyContent: "centre" }}>
                <div>
                  MONTHLY FEE START DATE
                  <div className="date-picker-container">
                    <DatePicker
                      selected={startDate}
                      onChange={(date) => setStartDate(date)}
                      shouldCloseOnSelect={true}
                      inline
                      filterDate={(date) => isAllowedDate(date)}
                      monthsShown={2} // Show two months
                    />
                  </div>
                  <br />
                </div>
              </div>
            </section>

            <section className="distex">
              <div className="distext">
                DISCLOSURE
                <br />
                <br />
                <label style={{ display: "flex" }}>
                  <input
                    className="radiomargin"
                    type="checkbox"
                    onChange={() => setHasAgreed(!hasAgreed)}
                    value={hasAgreed}
                    checked={hasAgreed}
                  />
                  <a href="terms-of-service" target="_blank">
                    I HEREBY ACCEPT THE TERMS AND CONDITIONS{" "}
                    <FaExternalLinkAlt />
                  </a>
                </label>
                <label style={{ display: "flex" }}>
                  <input
                    className="radiomargin"
                    type="checkbox"
                    onChange={() => setHasAgreedWhatsapp(!hasAgreedWhatsapp)}
                    value={hasAgreedWhatsapp}
                    checked={hasAgreedWhatsapp}
                  />
                  <a href="terms-of-service" target="_blank">
                    I CONSENT TO OFF BEAT PLUS COMMUNICATING WITH ME VIA
                    WHATSAPP IN THE FUTURE. <FaExternalLinkAlt />
                  </a>
                </label>
              </div>
            </section>
            <section className="distex payment-link">
              <label htmlFor="sendPaymentLink">
                <input
                  className="radiomargin"
                  type="checkbox"
                  id="sendPaymentLink"
                  onChange={() => {
                    setHasToSendPaymentLink(!hasToSendPaymentLink);
                    setPaymentLinkEmail(hasToSendPaymentLink ? "" : email);
                  }}
                  value={hasToSendPaymentLink}
                  checked={hasToSendPaymentLink}
                />
                <span>SEND PAYMENT LINK</span>
              </label>
              {hasToSendPaymentLink && (
                <>
                  <div className="form-item fi-20">
                    <label>Email Address:</label>
                    <input
                      type="email"
                      value={paymentLinkEmail}
                      onChange={(e) => setPaymentLinkEmail(e.target.value)}
                      placeholder="Type your email address here"
                    />
                  </div>
                  <div className="form-item fi-20">
                    <label>Confirm Email Address:</label>
                    <input
                      type="email"
                      value={paymentLinkConfirmEmail}
                      onChange={(e) =>
                        setPaymentLinkConfirmEmail(e.target.value)
                      }
                    />
                  </div>
                  <div className="form-item fi-30">
                    <div className="form-item fi-60">
                      <label>Code:</label>
                      <select
                        value={paymentLinkCode}
                        onChange={(e) => setPaymentLinkCode(e.target.value)}
                        className="no-spinners"
                      >
                        {phoneCodes.map((option, index) => (
                          <option key={index} value={option.code}>
                            {`${option.country} (${option.code})`}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-item fi-60">
                      <label>Cellphone Number:</label>
                      <input
                        type="tel"
                        value={paymentLinkPhone}
                        onChange={(e) => setPaymentLinkPhone(e.target.value)}
                      />
                    </div>
                  </div>
                </>
              )}
            </section>

            <div className="btn-cont mobile-btn-cont">
              <button
                className="btn mobile-btn-join"
                type="submit"
                disabled={isLoading || isHeadingToAdumo}
              >
                {selectedAnnualValue === "option1" ||
                selectedAnnualValue === "option2"
                  ? isLoading
                    ? "Processing Now..."
                    : isHeadingToAdumo
                    ? "Redirecting to Adumo..."
                    : "MAKE PAYMENT with CREDIT CARD"
                  : "SAVE AND PROCEED TO NEXT STEP"}
              </button>
              <button
                className="btn mobile-btn-join"
                type="button"
                onClick={() => {
                  if (typeof window !== "undefined") window.location.href = "/";
                }}
                style={
                  isLoading || isHeadingToAdumo
                    ? { cursor: "not-allowed", pointerEvents: "none" }
                    : {}
                }
                disabled={isLoading || isHeadingToAdumo}
              >
                CANCEL
              </button>
            </div>
          </form>
        </div>
      </section>
    );
  } else if (currentStep === 4) {
    return (
      <section className="section-bg" id="join-now-form3">
        <div className="join-cont">
          <div className="count-cont">
            <span
              onClick={() => {
                setCurrentStep(1);
              }}
            >
              01
            </span>
            <span
              onClick={() => {
                setCurrentStep(2);
              }}
            >
              02
            </span>
            <span
              onClick={() => {
                setCurrentStep(3);
              }}
            >
              03
            </span>
            <span
              className="active"
              onClick={() => {
                setCurrentStep(4);
              }}
            >
              04
            </span>
          </div>
          <div className="join-head-cont">
            <h2 className="upgrade-today-title">Payment Details</h2>
            <h4>Debit Order Details</h4>
          </div>
          <form onSubmit={handleSubmitStep3}>
            <section>
              <div className="form-item fi-100">
                <label>Account Holder Name</label>
                <input
                  type="text"
                  value={accountHolderName}
                  onChange={(e) => setAccountHolderName(e.target.value)}
                />
              </div>
              <div className="form-item fi-100">
                <label>Account Number</label>
                <input
                  type="number"
                  value={accountNumber}
                  onChange={(e) => setAccountNumber(e.target.value)}
                />
              </div>
            </section>
            <section>
              <div className="form-item fi-50">
                <label>Account Type:</label>
                <select
                  value={accountType.Id}
                  onChange={(e) => {
                    setAccountType(
                      accountTypes.find(
                        (accountType) => accountType.Id === +e.target.value
                      )
                    );
                  }}
                >
                  <option value="" disabled>
                    Please Select
                  </option>
                  {accountTypes.map((option) => (
                    <option key={option.Id} value={option.Id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-item fi-50">
                <label>Bank Name:</label>
                <select
                  value={bank.Id}
                  onChange={(e) =>
                    setBank(banks.find((bank) => bank.Id === +e.target.value))
                  }
                >
                  <option value="" disabled>
                    Please Select
                  </option>
                  {banks.map((option) => (
                    <option key={option.Id} value={option.Id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>
            </section>
            <div className="btn-cont">
              <button
                className="btn"
                type="submit"
                disabled={isLoading || isHeadingToAdumo}
              >
                {isLoading
                  ? "Processing Now..."
                  : isHeadingToAdumo
                  ? "Redirecting to Adumo..."
                  : "MAKE PAYMENT with CREDIT CARD"}
              </button>
            </div>
          </form>
        </div>
      </section>
    );
  } else {
    if (hasToSendPaymentLink) {
      return (
        <section>
          <div className="join-cont complete unsucessful">
            {isAdumoStatus === "failed" && (
              <div>
                <button
                  className="btn"
                  type="button"
                  onClick={() => {
                    handleRetrySignupVirtual(
                      JSON.parse(
                        window.sessionStorage.getItem(
                          "adumo-payment-retry-object"
                        )
                      ),
                      true
                    );
                  }}
                >
                  Re-Send Payment Link Request
                </button>
              </div>
            )}
            <div className="join-head-cont">
              <h3>
                <em
                  style={{
                    backgroundColor: "yellow",
                    color: "#111",
                    padding: "5px 10px",
                    borderRadius: "5px",
                  }}
                >
                  {adumoMessage}
                </em>
              </h3>
            </div>
            <div className="btn-cont">
              <button
                className="btn back-home-btn"
                type="button"
                onClick={() => {
                  typeof window !== "undefined" && window.location.replace("/");
                }}
              >
                BACK TO HOME
              </button>
            </div>
          </div>
        </section>
      );
    } else {
      if (isAdumoStatus === "failed") {
        return (
          <section>
            <div className="join-cont complete unsucessful">
              <div className="join-head-cont">
                <h2>SIGN UP UNSUCCESSFUL</h2>
              </div>
              <div>
                <button
                  className="btn"
                  type="button"
                  onClick={() => {
                    handleRetrySignupVirtual(
                      JSON.parse(
                        typeof window !== "undefined" &&
                          window.sessionStorage.getItem(
                            "adumo-payment-retry-object"
                          )
                      )
                    );
                  }}
                  disabled={retryLoader}
                >
                  {retryLoader ? "Processing Now..." : "RETRY PAYMENT"}
                </button>
              </div>
              <div className="join-head-cont">
                <h3>
                  PAYMENT FAILED:{" "}
                  <em
                    style={{
                      backgroundColor: "yellow",
                      color: "#111",
                      padding: "5px 10px",
                      borderRadius: "5px",
                    }}
                  >
                    {adumoMessage}
                  </em>
                </h3>
              </div>
              <div className="btn-cont">
                <button
                  className="btn back-home-btn"
                  type="button"
                  onClick={() => {
                    typeof window !== "undefined" &&
                      window.location.replace("/");
                  }}
                >
                  BACK TO HOME
                </button>
              </div>
            </div>
          </section>
        );
      }

      if (isAdumoStatus === "pending_approval") {
        return (
          // add pending approval section
          <section>
            <div className="join-cont complete unsucessful">
              <div className="join-head-cont">
                <h2>COMPLETING SIGNUP</h2>
              </div>
              <div className="join-head-cont">
                <em>WAIT A BIT WHILE COMPLETING SIGNUP PROCESS...</em>
              </div>
            </div>
          </section>
        );
      }

      return (
        <section>
          <div className="join-cont complete unsucessful">
            <div className="join-head-cont">
              <h2>SIGN UP COMPLETE</h2>
            </div>
            <div className="btn-cont">
              <button
                className="btn back-home-btn"
                type="button"
                onClick={() => {
                  typeof window !== "undefined" && window.location.replace("/");
                }}
              >
                BACK TO HOME
              </button>
            </div>
          </div>
        </section>
      );
    }
  }
}

export default SignUpForm;
